import * as React from "react";
import { Modal, Button } from "antd";
import { disclaimerStore } from "Stores/DisclaimerStore";
import { observer } from "mobx-react";

export const Disclaimer = observer(
  class Disclaimer extends React.Component<{}, {}> {
    componentDidMount() {
      disclaimerStore.fetch();
    }

    public render() {
      return (
        <Modal
          open={true}
          closable={false}
          title={
            <div className="text-center">
              <h2>{disclaimerStore.data.name}</h2>
              <p>{disclaimerStore.data.description}</p>
              {/* <p>{t('Please read the following disclaimer and confirm your approval.')}</p> */}
            </div>
          }
          footer={
            <Button type="primary" onClick={disclaimerStore.confirmDisclaimer} className="btn-fluid">
              {disclaimerStore.data.button}
            </Button>
          }
        >
          <article
            dangerouslySetInnerHTML={{
              __html: disclaimerStore.data.content,
            }}
          />
        </Modal>
      );
    }
  }
);
